import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  searchedSpare: null,
  searchedFinalSpare: {},
  hideIncomePrices: false,
  showReferencePrice: false,
  hideRetailPrices: false,
  pendingNoteSearch: null,
}

const sparesSlice = createSlice({
  name: 'sparesSlice',
  initialState,
  reducers: {
    setSearchedSpare: (state, action) => {
      state.searchedSpare = action.payload
    },
    setSearchedFinalSpare: (state, action) => {
      state.searchedFinalSpare = action.payload
    },
    setHideIncomePrices: (state, action) => {
      state.hideIncomePrices = action.payload
      localStorage.setItem('hideIncomePrices', action.payload)
      if (action.payload) {
        state.hideRetailPrices = false
      }
    },
    setShowReferencePrice: (state, action) => {
      state.showReferencePrice = action.payload
      localStorage.setItem('showReferencePrice', action.payload)
    },
    setHideRetailPrices: (state, action) => {
      state.hideRetailPrices = action.payload
      if (action.payload) {
        state.hideIncomePrices = false
      }
    },
    setPendingNoteSearch: (state, action) => {
      state.pendingNoteSearch = action.payload
    },
    clearPendingNoteSearch: (state) => {
      state.pendingNoteSearch = null
    },
  },
})

export const {
  setSearchedSpare,
  setSearchedFinalSpare,
  setHideIncomePrices,
  setShowReferencePrice,
  setHideRetailPrices,
  setPendingNoteSearch,
  clearPendingNoteSearch,
} = sparesSlice.actions

export const selectSearchedFinalSpare = (state) =>
  state.sparesSlice.searchedFinalSpare
export const selectSearchedSpare = (state) => state.sparesSlice.searchedSpare
export const selectHideIncomePrices = (state) =>
  state.sparesSlice.hideIncomePrices
export const selectShowReferencePrice = (state) =>
  state.sparesSlice.showReferencePrice
export const selectHideRetailPrices = (state) =>
  state.sparesSlice.hideRetailPrices
export const selectPendingNoteSearch = (state) =>
  state.sparesSlice.pendingNoteSearch

export default sparesSlice.reducer
